module.exports = __webpack_public_path__ + "img/ring_r_skip_0_1@2x.1a1cd626.png";